import React from 'react';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import PaymentPresenter from '../../../../../../../../../../presenters/Membership/PaymentPresenter';
import Row from '../../../../../../../../../../components/Row';
import Column from '../../../../../../../../../../components/Column';
import { validationSchema } from '../../../../../../../../../../forms/paymentForm';

const NewPaymentForm = (props) => {
  const { initialValues, onSubmit, availablePaymentTypes } = props;

  const formik = useFormik({
    initialValues,
    onSubmit,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { handleSubmit, setFieldValue } = formik;

  const handlePaymentChange = ({ target }) => {
    const { id, value } = target;
    setFieldValue(id, value);
  };

  const typeOptions = availablePaymentTypes.map((type) => {
    return {
      label: PaymentPresenter.typeReadable({
        paymentType: type,
      }),
      value: type,
    };
  });
  return (
    <tr>
      <td className="cell"> -- </td>
      <td className="cell"> -- </td>
      <td colSpan="2">
        <form onSubmit={handleSubmit}>
          <Row>
            <Column>
              <select id="paymentType" onChange={handlePaymentChange} required>
                {typeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </Column>
            <Column>
              <button className="action-button" type="submit">
                Create Payment
              </button>
            </Column>
          </Row>
        </form>
      </td>
      <td className="cell"> -- </td>
    </tr>
  );
};

export default NewPaymentForm;

NewPaymentForm.propTypes = {
  initialValues: PropTypes.shape().isRequired,
  availablePaymentTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSubmit: PropTypes.func.isRequired,
};
